import { useEffect, useRef, useState } from "react";
import { useSearchBox } from "react-instantsearch";
import { useDispatch, useSelector } from "react-redux";
import { suggestionsActions } from "../../store/redux/store";
import ReactHtmlParser from "html-react-parser";
import dompurify from "dompurify";
import "./CustomSuggestionHits.scss";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { suggestionsHitsAnimation } from "./suggestions-animations";

const CustomSuggestionHits = () => {
    const customHits = useSelector((state) => state.suggestions);
    const { query, refine: setQuery } = useSearchBox();
    const dispatch = useDispatch();

    const componentRef = useRef(null);

    // eslint-disable-next-line
    const [instantSearchUiState, setInstantSearchUiState] = useState({
        query,
    });

    const setSuggestion = (hit) => {
        setQuery(hit);
        resetCollectionsSuggestions();
        updateCollectedSuggestions(hit);
    };
    const updateCollectedSuggestions = (payload) => {
        dispatch(suggestionsActions.updateSuggestions(payload));
    };
    const resetCollectionsSuggestions = () => {
        dispatch(suggestionsActions.resetSuggestions());
    };
    const [suggestionsList, setSuggestionsList] = useState();

    useEffect(
        () => {
            setSuggestionsList(
                customHits.map((hit, hitIndex) => {
                    const highlightedString = (hit, query) => {
                        query = query.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&');
                        var regEx = new RegExp(query, "gi");
                        return query.length > 0
                            ? hit.replace(
                                  regEx,
                                  "<strong>" + query + "</strong>",
                              )
                            : hit;
                    };
                    const finalString = ReactHtmlParser(
                        dompurify.sanitize(highlightedString(hit, query)),
                    );
                    return (
                        <li
                            key={hitIndex}
                            className={["suggestion-hit__list-item"]}
                        >
                            <button
                                className={["suggestion-hit__button"]}
                                type="button"
                                onClick={(event) => {
                                    event.preventDefault();
                                    setSuggestion(hit);
                                }}
                            >
                                <span>{finalString}</span>
                            </button>
                        </li>
                    );
                }),
            );
        },
        // eslint-disable-next-line
        [customHits],
    );

    const shouldRenderSuggestions =
        suggestionsList && suggestionsList.length > 0;
    const timeline = useRef(gsap.timeline());
    useGSAP(
        () => {
            timeline.current.add(suggestionsHitsAnimation());
        },
        {
            dependencies: [shouldRenderSuggestions],
            scope: componentRef.current,
        },
    );

    return shouldRenderSuggestions ? (
        <>
            <div className={["suggestion-hit__container"]} ref={componentRef}>
                <ul>{suggestionsList}</ul>
            </div>
        </>
    ) : null;
};

export default CustomSuggestionHits;
